import { render, staticRenderFns } from "./rewardDetail.vue?vue&type=template&id=7331b090&scoped=true&"
import script from "./rewardDetail.vue?vue&type=script&lang=ts&"
export * from "./rewardDetail.vue?vue&type=script&lang=ts&"
import style0 from "./rewardDetail.vue?vue&type=style&index=0&id=7331b090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7331b090",
  null
  
)

export default component.exports